var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import FileSaver from 'file-saver';

function checkStatus(response) {
    var status = response.status,
        statusText = response.statusText;


    if (status >= 200 && status < 300) {
        return response;
    }

    var error = new Error(statusText);
    error.response = response;

    throw error;
}

function parseJSON(response) {
    return response.json();
}

export default function upload() {
    var uploadConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var file = arguments[1];

    var test = false;

    if (test) {
        return new Promise(function (resolve, reject) {
            window.setTimeout(function () {
                resolve();
            }, Math.random() * 2000 + 1000);
        });
    }

    var url = uploadConfig.url,
        config = uploadConfig.config;

    var body = new FormData();

    body.append('file', file, file.name);

    return fetch(url, _extends({}, config, { body: body })).then(checkStatus).then(parseJSON).then(function (data) {
        return Promise.resolve(data);
    }).catch(function (error) {
        return Promise.reject(error);
    });
}